import {Fragment, useEffect, useState} from 'react';
import './InformationStrip.scss';
import Outlinelock from '../../../../assets/icons/outline-lock.png';
import CloseX from '../../../../assets/icons/closeX.png';
import GovIlSite from '../../../../assets/icons/govilSite.png';
import HttpsSite from '../../../../assets/icons/httpsSite.png';
import Lock from '../../../../assets/icons/lock.png';
import OutlineCheckmarkCircle from '../../../../assets/icons/outline-checkmark-circle-2.svg';

declare function Translate(key: string): string;


export let translateText = [
    {
        label: 'N_General_system_title_2',
        value: 'main header',
    },
    {
      label: 'N_General_system_security_check',
      value: 'main header link',
    },
    {
        label: 'N_General_close',
        value: 'close',
    },
    {
        label: 'N_General_system_security_subtitle_1',
        value: 'header block 1',
    },
    {
        label: 'N_General_system_security_info_1',
        value: 'paragraph 1',
    },
    
    {
        label: 'N_General_system_security_subtitle_2',
        value: 'header block 2',
    },
    {
        label: 'N_General_system_security_info_2',
        value: 'paragraph 2',
    },
    
    {
      label: 'N_General_system_security_info_2_1',
      value: 'paragraph 2 1'
    },
    {
      label: 'N_General_system_security_info_2_2',
      value: 'paragraph 2 2',
    },

    {
        label: 'N_General_system_security_info_2_3',
        value: 'paragraph 2 3',
    },
    {
        label: 'N_General_system_security_info_3',
        value: 'buttom header information strip',
    },
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'israeli passport'
    },
    {
        label: 'N_General_SignUp_lobby_info_6',
        value: 'israeli ID'
    },
    {
        label: 'N_General_SignUp_lobby_info_7',
        value: 'israeli Immigrant certificate'
    },
    {
        label: 'N_General_SignUp_lobby_info_8',
        value: 'two questions'
    },
    {
        label: 'N_General_SignUp_lobby_info_9',
        value: 'credit card'
    },
    {
        label: 'N_General_SignUp_kupa_0',
        value: 'HMO'
    },
    {
        label: 'N_General_SignUp_lobby_info_11',
        value: 'Code of the Population Authority Clerk'
    },
    {
        label: 'N_General_SignUp_lobby_info_14',
        value: 'biometric passport details information'
    },
  ];


const  ToggleInformationStrip = (props) => {   
        
    const[showStrip,setShowStrip] = useState(false); 
    
    useEffect(() => {
        setShowStrip(props.showListIS);
    },[props.showListIS]);
            
    var closeStrip = () => {
        setShowStrip(false);
        props.onCloseClicked();
    }

    return(        
        <div className={showStrip ? "displaySetBlock": "displaySetNone"}>
            <div className='informationStreepDetails'>               
                <div className='blocks flexContainer'>
                    <div className='informationBlock'>
                        <img src={GovIlSite} alt="" aria-hidden="true"></img>
                        <div className='headerBlock'>{Translate(translateText[3].label)}</div>
                        <p>{Translate(translateText[4].label)}</p>
                    </div>
                    <div className='informationBlock'>
                        <img src={HttpsSite} alt="" aria-hidden="true"></img>
                        <div className='headerBlock'>{Translate(translateText[5].label)}</div>
                        <p>{Translate(translateText[6].label)} {Translate(translateText[7].label)} 
                            <img className='imgLock' src={Lock} alt="" aria-hidden="true"/>
                                {Translate(translateText[8].label)} <span>{Translate(translateText[9].label)}</span>
                        </p>
                    </div>
                    <div id="closeInformation" className="close-information">
                        <button className="close-information-icon" onClick={closeStrip}>
                            <img src={CloseX} alt={Translate("N_General_close")}></img>
                        </button>
                        <span className="close-text">{Translate("N_General_close")}</span>
                    </div>
                </div>
                
                <div className='ISwarning'><img src={OutlineCheckmarkCircle} alt=""></img> 
                    {Translate("N_General_system_security_info_3")}
                </div>
                <div id="closeInformationMobile" className="close-information">
                    <button className="close-information-icon" onClick={closeStrip}>
                        {Translate("N_General_system_security_info_butten")}
                    </button>                    
                </div>
            </div>
        </div>
    );
};


const InformationStrip = () => {
    const[showListInformatioStrip,setShowListInformatioStrip] = useState(false);

    const handleToggleClick = () => {
        setShowListInformatioStrip(!showListInformatioStrip);       
    }

    return (        
        <Fragment>         
            <div className='informationStripDiv'>
                <div onClick={handleToggleClick} className='mainHeader '>
                    <div className='flexContainer'>
                        <img src={Outlinelock} alt="" aria-hidden="true"></img>
                        <div className='innerMainHeader'>
                            {Translate(translateText[0].label)}  
                        </div>
                        <div className='innerMainHeader underLine bold'>
                            {Translate(translateText[1].label)}
                        </div>
                        <div className={showListInformatioStrip ? 'arrowUpWhite' : 'arrowDownWhite'}></div>
                    </div>
                </div>
                
                <ToggleInformationStrip showListIS={showListInformatioStrip} onCloseClicked={handleToggleClick}/>
            </div>                            
        </Fragment>
    );

};
export default InformationStrip;
